import MobileIcon from '@repo/ui/src/components/Icons/MobileIcon';
import ReplacementIcon from '@repo/ui/src/components/Icons/ReplacementIcon';
import SupportIcon from '@repo/ui/src/components/Icons/SupportIcon';
import useTranslation from '@repo/ui/src/context/Translation/useTranslation';

export const GrillAssistanceInfo = () => {
  const { t } = useTranslation();
  const iconStyles = 'tw-pr-2 tw-w-6';

  return (
    <>
      <h6 className="tra-text-web-heading-6">
        {t('productDetailPageContent.helpText', undefined, {
          default: "We're Here to help",
        })}
      </h6>
      <hr className="tw-border-2 tw-w-10 tw-border-brand-300" />
      <div className="tw-grid tw-gap-4 tw-grid-cols-2">
        <p>
          <span className={iconStyles}>
            <ReplacementIcon role="presentation" />
          </span>
          {t('productDetailPageContent.replacementText', undefined, {
            default: 'Fast Replacements',
          })}
        </p>
        <p>
          <span className={iconStyles}>
            <MobileIcon role="presentation" />
          </span>
          {t('productDetailPageContent.supportText', undefined, { default: '24/7 Live Support' })}
        </p>
        <p>
          <span className={iconStyles}>
            <SupportIcon role="presentation" />
          </span>
          {t('productDetailPageContent.claimsText', undefined, { default: 'Easy Online Claims' })}
        </p>
      </div>
    </>
  );
};
